export default __webpack_public_path__ + "static/media/help-icon2.37afdd55.png";